<template>
  <div class="form-group form-group--select" :class="classes">
    <div class="form-element__container">

      <!-- Control and label -->
      <div class="form-control__container">        
        <select :style="`opacity: ${!hasValue && !isMultipleSelect ? 0 : ''}`" :id="control_id" ref="controlEl" @focus="fcOnFocus" @blur="fcOnBlur" class="form-control" v-model="control_value"  :placeholder="_placeholder" v-bind="$attrs" >
          <slot></slot>
        </select>
        <label v-if="label" :for="control_id" class="form-control__label">
          <slot name="label" :label="label">{{label}}</slot>
        </label>
      </div>
    </div>


    <div class="flexbox row form-control__additional-content-slot">
      <!-- Errors -->
      <div v-if="show_error" class="form-control__error-text">{{errors[0]}}</div> 
      <!-- Helper slot -->
      <div v-else-if="$slots['help']" class="form-control__helper-text">
        <slot name="help"></slot>
      </div>
    </div>

  </div>
</template>

<script>
import FormControl from '../../mixins/form-control'
import Validatable from '../../mixins/validatable'

export default {

  name: 'NSelect',

  mixins: [FormControl, Validatable],

  computed: {
    isMultipleSelect() {
      return this.$attrs.multiple !== undefined
    },

    hasValue() {
      // Support <select>'s with a selectable `null` option
      return this.hasEnabledNullValueOption
        ? this.control_value !== undefined && this.control_value !== ''
        : this.control_value !== undefined && this.control_value !== null && this.control_value !== ''
    },

    hasEnabledNullValueOption() {
      return this.$slots.default
        .filter(option => option.data.domProps && option.data.domProps.value === null)
        .filter(option => option.data.attrs == null || option.data.attrs.disabled === undefined)
        .length > 0
    },
  },
}
</script>